

















































































































































































































































































































































































































































































































































































































































































































































































































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

import { IPlaningTransfer } from '@/interface/IPlanningProviderResponse'
import DatePickerOnColumn from "@/components/planning/DatePickerOnColumn.vue"
import DatePickerOnColumnDisabled from "@/components/planning/DatePickerOnColumnDisabled.vue"
import DatePickerMonthOnColumn from "@/components/planning/DatePickerMonthOnColumn.vue"
import DatePickerMonthOnColumnDisabled from "@/components/planning/DatePickerMonthOnColumnDisabled.vue"
import DialogInspection from "@/components/planning-cr/inspection/DialogInspection.vue"
import BankDialog, { IBankDetails } from "@/components/planning-cr/bank/BankDialog.vue"
import DeedDialog from "@/components/planning-cr/deed/DeedDialog.vue"
import DialogNoteOnColumn from '@/components/common/data-table/DialogNoteOnColumn.vue'
import CheckBoxOnColumn from '@/components/common/data-table/CheckBoxOnColumn.vue'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import 'vue2-timepicker/dist/VueTimepicker.css'

import { SetJsonTransferSave, SetColumnFreeze } from '@/resource/planning-cr/DataTableTransferPlanning'
import { TimeOut } from '@/utils/common'

import { PdpaApi, SapApi } from '@/api'
import { IDataTableTransferPlanning } from '@/resource/planning-cr/ModifyJsonData'
import { ValidateTransferSave } from '@/resource/planning-cr/TransferPlanningValidate'


import { config } from "@/config"
import { default as _Vue } from 'vue';

@Component({
	components: {
		DatePickerOnColumn,
		DatePickerMonthOnColumn,
		DatePickerMonthOnColumnDisabled,
		CheckBoxOnColumn,
		DatePickerOnColumnDisabled,
		DialogInspection,
		BankDialog,
		DialogNoteOnColumn,
		DeedDialog,
		VueTimepicker
	}
})
export default class DataTableTransferPlanning extends Vue { 
	@Prop(Function) public notifcation: any
	@Prop(Function) public openNotification: any
	@Prop(Function) public isloadding: any
	// @Prop(Function) public UpdateDataTableByUnit: any

	@Prop() public masterContractStatus: any
	@Prop() public masterReceivePromotionData: any
	@Prop() public masterJoinEventData: any
	@Prop() public masterPurposeOfBuyData: any
	@Prop() public masterInspection1AppointmentStatusData: any
	@Prop() public masterTransferStatus: any
	@Prop() public masterTransferType: any
	@Prop() public masterTransferPlanOperation: any
	@Prop() public masterPayStatusType: any
	@Prop() public masterPayStatusCusOverPayType: any
	@Prop() public masterBankReason: any
	@Prop() public crNameItemData: any
	@Prop() public emailTypeId: any


	topic1 = "e1aa5622-5acd-4f1b-bfd0-51143b690eec"

	loading = false
	menu = false
	columnAddressLock = true
	columnCustomerNameLock = true
	dialog = false
	snackbarTextMessage = ""
	selected = [] as any[]
	search = "" as string
	tableData = [] as any[]
	options = { itemsPerPage: 20 } as any
	footerProps = {  'items-per-page-options': [10, 20, 30, 50, -1] } as any

	masterContractStatusItem = [] as any[]
	masterReceiveDataItem = [] as any[]
	masterJoinEventDataItem = [] as any[]
	masterPurposeOfBuyDataItem = [] as any[]
	masterInspection1AppointmentStatusDataItem = [] as any[]
	masterTransferStatusItem = [] as any[]
	masterTransferTypeItem = [] as any[]
	masterBankReasonItem = [] as any[]
	masterTransferPlanOperationItem = [] as any[]
	masterPayStatusTypeItem = [] as any[]
	masterPayStatusCusOverPayTypeItem = [] as any[]
	objectDataChange = [] as any[]
	masterCRname = [] as any[]
	tempTableData = {
		unitId: 0 as number,
		transferTypeId: 0 as number,
	} as any
	getMasterDataByTypeEmptyObject = [{ id: 0, code: "01", idLevel1: 0, descriptionTH: "", descriptionEN: "", type: "", displayOrder: 0, flagActive: 0 }] as any
	jsonDataSaveTransfer = [] as any[]
	jsonBankLists = [] as any[]
	productId = "" as string

	isColumnQC: boolean = false
	isColumnIBNonIB: boolean = false
	pdpaHeader: PdpaApi.IPdpaCollection[] = []
	masterInspectionTime = [] as any[]

	isNumberRule(value: any) {
		
		console.log("value : ",value)

		let isCheck = true
		if (value == null)
		{
			isCheck = true
		}
		else if (value.name != undefined)
		{
			let obj =  this.masterInspectionTime.filter((timeNew) => timeNew.name == value.name)
			if(obj.length == 0)
			{
				isCheck = false
			}
			else{
				isCheck = true
			}
		}
		else
		{
			let obj =  this.masterInspectionTime.filter((timeNew) => timeNew.name == value)
			if(obj.length == 0)
			{
				isCheck = false
			}
			else{
				isCheck = true
			}

			if (value == "")
			{
				isCheck = true
			}
		}

		console.log("isCheck : ",isCheck)

      	return isCheck;
    }
	
	tableSelectAll (event: any) {
        if (event.value) this.selected = this.tableData
        if (!event.value) this.selected = []
    }

	getCrNameItemDataList (crId: any) {
        let getCrNameItemData = this.crNameItemData.filter( (x: any) => x.value == crId || x.active == true)
        return getCrNameItemData
    }

	filterOnlyCapsText (value: any, search: any, item: any) {
	return value != null &&
		search != null &&
		typeof value === 'string' &&
		value.toString().indexOf(search) !== -1
    }

	headerDataTable () {
		const header =  [
			{ text: "ยูนิต", value: "unitCode", width: 120, class: "fixed-unit", align: "start fixed-unit", sortable: false },
			{ text: "บ้านเลขที่", value: "addressNo", width: 120 , class: "fixed-address", align: "start fixed-address", sortable: false },
			{ text: "ชื่อลูกค้า", value: "customerName", width: 300 , class: "fixed-name", align: "start fixed-name", sortable: false },
			{ text: "VIP", value: "vipStatus", width: 150, align: "center", sortable: false },
			{ text: "สถานะขาย", value: "saleStatus", align: "center", width: 120, sortable: false },
			{ text: "Model", value: "model", width: 150, align: "center", sortable: false, class: "sv-model" },
			{ text: "ราคาตามสัญญา", value: "contractUnitPrice", width: 150, align: "end", sortable: false, class: "sv-contractUnitPrice" },
			{ text: "ราคาต่อ ตรม/ตรว", value: "areaValue", width: 150, align: "end", sortable: false, class: "sv-areaValue" },
			{ text: "ขนาดที่ดิน/พื้นที่ตามโฉนด", value: "landArea", width: 170, align: "end", sortable: false, class: "sv-landArea" },
			{ text: "พื้นที่ใช้สอยตามโฉนด", value: "usageArea", width: 150, align: "end", sortable: false, class: "sv-usageArea" },
			{ text: "ขนาดที่ดิน/พื้นที่ตามสัญญา", value: "landSize", width: 170, align: "end", sortable: false, class: "sv-landSize" },
			{ text: "พื้นที่ใช้สอยตามสัญญา", value: "usageSize", width: 150, align: "end", sortable: false, class: "sv-usageSize" },
			{ text: "ราคาขายสุทธิ", value: "netPrice", width: 150, align: "end", sortable: false, class: "sv-netPrice" },
			{ text: "เบอร์ติดต่อ", value: "mobilePhone", align: "end", width: 150, sortable: false, class: "sv-mobilePhone" },
			{ text: "สัญชาติ", value: "country", id: "1234", width: 120, align: "center", sortable: false, class: "sv-country" },
			{ text: "Email", value: "email", width: 250, sortable: false, class: "sv-email" },
			{ text: "วันที่จอง", value: "bookActivityDate", align: "center", width: 150 ,sortable: false, class: "sv-bookActivityDate" },
			{ text: "วันที่ทำสัญญา", value: "signActivityDate", align: "center", width: 150 ,sortable: false, class: "sv-signActivityDate" },
			{ text: "วันที่โอนตามสัญญา", value: "contractTransferDate", align: "center", width: 150 ,sortable: false, class: "sv-contractTransferDate" },
			{ text: "วันที่โอนตามจดหมายขอ ขยาย/ลด เวลา", value: "letterRequestExtendReduceTransferDate", width: 230, align: "center", sortable: false , class: "sv-letterRequestExtendReduceTransferDate" },
			{ text: "งวดสุดท้าย", value: "paymentLast", width: 120, align: "center", sortable: false, class: "sv-paymentLast" },
			{ text: "สถานะติดต่อ", value: "contactStatusId", width: 230, align: "start fixed-contract-status", sortable: false, class: "sv-contactStatusId" },
			{ text: "รับโปร/ไม่รับโปร", value: "receivePromotionId", width: 230, class: "fixed-contract-status sv-receivePromotionId", align: "start fixed-contract-status", sortable: false},
			{ text: "เข้าร่วมงาน Event", value: "joinEventId", width: 230, class: "fixed-contract-status sv-joinEventId", align: "start fixed-contract-status", sortable: false},
			{ text: "วัตถุประสงค์ในการซื้อ", value: "purposeOfBuyId", width: 230, class: "fixed-contract-status sv-purposeOfBuyId", align: "start fixed-contract-status", sortable: false},
			{ text: "ลูกค้าต้องการฝาก Stock", value: "customerDepositStock", width: 170, align: "start fixed-contract-status", sortable: false, class: "sv-customerDepositStock" },
			{ text: "สถานะการส่งมอบ", value: "sendRoomStatus", width: 200, align: "center fixed-delivery-status", sortable: false, class: "sv-sendRoomStatus" },
			{ text: "วันที่ส่งห้อง 1", value: "inspection1SendRoomDate", width: 200, align: "center fixed-delivery-status", sortable: false, class: "sv-inspection1SendRoomDate" },
			{ text: "สถานะการนัด/เข้าตรวจ 1", value: "inspection1AppointmentStatusId", width: 230, align: "center fixed-delivery-status", sortable: false, class: "sv-inspection1AppointmentStatusId" },
			{ text: "วันที่นัดลูกค้าตรวจ 1", value: "inspection1PlanCRDate", width: 200, align: "center fixed-delivery-status", sortable: false, class: "sv-inspection1PlanCRDate" },
			{ text: "เวลาที่นัดลูกค้าตรวจ 1	", value: "inspection1PlanCRTime", width: 180, align: "center fixed-delivery-status", sortable: false, class: "sv-inspection1PlanCRTime" },
			{ text: "ชื่อบริษัทรับตรวจบ้าน", value: "flagInspectorContractor", width: 210, align: "center fixed-delivery-status", sortable: false},
			{ text: "CR Note", value: "crComment", width: 300, align: "center fixed-delivery-status", sortable: false, class: "sv-crComment" },
			{ text: "PJ Note", value: "pjComment", width: 300, align: "center fixed-delivery-status", sortable: false, class: "sv-pjComment" },
			{ text: "สถานะห้องหลังตรวจ 1", value: "inspection1TypeText", width: 150, align: "center fixed-delivery-status", sortable: false, class: "sv-inspection1TypeText" },
			{ text: "ครั้งที่ตรวจล่าสุด	", value: "inspectionNumLatest", width: 150, align: "end fixed-delivery-status", sortable: false, class: "sv-inspectionNumLatest" },
			{ text: "วันที่ส่งห้องล่าสุด", value: "inspectionSendRoomDateLatest", width: 150, align: "center fixed-delivery-status", sortable: false, class: "sv-inspectionSendRoomDateLatest" },
			{ text: "สถานะการนัด/เข้าตรวจ ล่าสุด", value: "inspectionAppointmentStatusLatest", width: 180, align: "center fixed-delivery-status", sortable: false, class: "sv-inspectionAppointmentStatusLatest" },
			{ text: "วันที่นัดลูกค้าตรวจล่าสุด", value: "inspectionPlanCRDateLatest", width: 180, align: "center fixed-delivery-status", sortable: false, class: "sv-inspectionPlanCRDateLatest" },
			{ text: "เวลาที่นัดลูกค้าตรวจล่าสุด", value: "inspectionPlanCRTimeLatest", width: 180, align: "center fixed-delivery-status", sortable: false, class: "sv-inspectionPlanCRTimeLatest" },
			{ text: "สถานะห้องหลังตรวจล่าสุด", value: "inspectionTypeTextLatest", width: 180, align: "center fixed-delivery-status", sortable: false, class: "sv-inspectionTypeTextLatest" },
			{ text: "ข้อมูลตรวจห้อง", value: "actionInspectionData", width: 120, align: "start fixed-delivery-status", sortable: false, class: "sv-actionInspectionData" },
			{ text: "CR Plan", value: "crPlan", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-crPlan" },
			{ text: "วันที่นัดโอน", value: "transferPlanDate", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-transferPlanDate" },
			{ text: "วันที่ผิดนัดโอนกรรมสิทธิ์", value: "transferOutDateHistory", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-transferOutDateHistory" },
			{ text: "วันที่โอนจริง", value: "transferDateReal", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-transferDateReal" },
			{ text: "Active Transfer", value: "flagActiveTransfer", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-flagActiveTransfer" },
			{ text: "เดือนที่คาดว่าโอน", value: "expectTranMonth", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-expectTranMonth" },
			{ text: "สถานะการโอน", value: "transferStatusId", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-transferStatusId" },
			{ text: "ประเภทการโอน", value: "transferTypeId", width: 180, align: "center fixed-transfer-appointment", sortable: false, class: "sv-transferTypeId" },
			{ text: "สถานะสินเชื่อ", value: "bankCreditStatus", width: 200, align: "start fixed-bank", sortable: false, class: "sv-bankCreditStatus" },
			{ text: "Bank", value: "actionBanks", width: 80, align: "center fixed-bank", sortable: false, class: "sv-actionBanks" },
			{ text: "ธนาคารที่เลือกใช้", value: "bankName", width: 240, align: "start fixed-bank", sortable: false, class: "sv-bankName" },
			{ text: "เหตุผลที่ใช้ธนาคาร", value: "useBankReason", width: 200, align: "start fixed-bank", sortable: false, class: "sv-useBankReason" },
			{ text: "เหตุผลอื่นๆที่ใช้ธนาคาร", value: "useBankReasonOther", width: 300, align: "start fixed-bank", sortable: false, class: "sv-useBankReasonOther" },
			{ text: "หมายเหตุ(อัพเดทระบบ Quotation, CS Report 18)", value: "transferCRRemark", width: 300, align: "start fixed-transfer-appointment", sortable: false, class: "sv-transferCRRemark" },
			{ text: "ชื่อหลังโฉนด 1", value: "deedName1", width: 200, align: "start fixed-transfer-appointment", sortable: false, class: "sv-deedName1" },
			{ text: "ชื่อหลังโฉนด 2", value: "deedName2", width: 200, align: "start fixed-transfer-appointment", sortable: false, class: "sv-deedName2" },
			{ text: "ชื่อหลังโฉนด 3", value: "deedName3", width: 200, align: "start fixed-transfer-appointment", sortable: false, class: "sv-deedName3" },
			{ text: "ชื่อหลังโฉนด 4", value: "deedName4", width: 200, align: "start fixed-transfer-appointment", sortable: false, class: "sv-deedName4" },
			{ text: "เพิ่มชื่อหลังโฉนด", value: "actionAddDeedName", width: 140, align: "start fixed-transfer-appointment", sortable: false, class: "sv-actionAddDeedName" },
			{ text: "การดำเนินการ", value: "operationId", width: 200, align: "start fixed-transfer-appointment", sortable: false, class: "sv-operationId" },
			{ text: "เวลาการดำเนินการ", value: "operationTime", width: 160, align: "start fixed-transfer-appointment", sortable: false, class: "sv-operationTime" },
			{ text: "ยอดปลอดจำนอง", value: "mortgageValue", width: 160, align: "end fixed-transfer-appointment", sortable: false, class: "sv-mortgageValue" },
			{ text: "ยอดปลอดจำนองส่วนต่างของบริษัท", value: "mortgageCompValue", width: 230, align: "center fixed-transfer-appointment", sortable: false, class: "sv-mortgageCompValue" },
			{ text: "หมายเหตุ(อัพเดทอีเมลแจ้งโอน)", value: "lettTransRemark", width: 300, align: "center fixed-transfer-appointment", sortable: false, class: "sv-lettTransRemark" },
			{ text: "วันที่นัดโอนหลังการโอนลอย", value: "transferPlanDateSp", width: 180, align: "start fixed-transfer-appointment", sortable: false, class: "sv-transferPlanDateSp" },
			{ text: "ส่งอีเมลข้อมูลการโอน", value: "flagTransferLetter", width: 160, align: "start fixed-transfer-appointment", sortable: false, class: "sv-flagTransferLetter" },
			{ text: "ส่งอีเมลผิดนัดการโอน", value: "flagTransferOutLetter", width: 160, align: "start fixed-transfer-appointment", sortable: false, class: "sv-flagTransferOutLetter" },
			{ text: "ส่งอีเมลเปลี่ยนแปลงการโอน", value: "flagTransferChangeLetter", width: 160, align: "start fixed-transfer-appointment", sortable: false, class: "sv-flagTransferChangeLetter" },
			{ text: "ส่งอีเมลเลื่อนการโอน", value: "flagTransferAdjustLetter", width: 160, align: "start fixed-transfer-appointment", sortable: false, class: "sv-flagTransferAdjustLetter" },
			{ text: "ส่งอีเมลยกเลิกการโอน", value: "flagTransferCancelLetter", width: 160, align: "start fixed-transfer-appointment", sortable: false, class: "sv-flagTransferCancelLetter" },
			{ text: "ส่งอีเมลยกเลิกผิดนัดการโอน", value: "flagTransferOutCancelLetter", width: 160, align: "start fixed-transfer-appointment", sortable: false, class: "sv-flagTransferOutCancelLetter" },
			{ text: "จดหมายตรวจ 1", value: "inspectionLetter1", width: 250, align: "center fixed-letter", sortable: false, class: "sv-inspectionLetter1" },
			{ text: "จดหมายตรวจ 2(รับมอบ)", value: "inspectionLetter2", width: 250, align: "center fixed-letter", sortable: false, class: "sv-inspectionLetter2" },
			{ text: "จดหมายรับมอบเข้า HC(HC)", value: "receiveHCLetter", width: 250, align: "center fixed-letter", sortable: false, class: "sv-receiveHCLetter" },
			{ text: "จดหมาย1 (วันนัดโอน)", value: "transferPlanDateLetter1", width: 250, align: "center fixed-letter", sortable: false, class: "sv-transferPlanDateLetter1" },
			{ text: "ผิดนัด 1", value: "transferOut1", width: 250, align: "center fixed-letter", sortable: false, class: "sv-transferOut1" },
			{ text: "จดหมาย2 (วันนัดโอน)", value: "transferPlanDateLetter2", width: 250, align: "center fixed-letter", sortable: false, class: "sv-transferPlanDateLetter2" },
			{ text: "ผิดนัด 2", value: "transferOut2", width: 250, align: "center fixed-letter", sortable: false, class: "sv-transferOut2" },
			{ text: "สถานะชำระ 100%", value: "payStatus100pc", width: 250, align: "center fixed-payment", sortable: false, class: "sv-payStatus100pc" },
			{ text: "สถานะชำระ 100% คืนเงิน(ลูกค้าชำระเกิน)", value: "payStatus100pcCusOverPay", width: 240, align: "center fixed-payment", sortable: false, class: "sv-payStatus100pcCusOverPay" },
			{ text: "หมายเหตุ สถานะ 100%", value: "reasonStatus100pc", width: 230, align: "center fixed-payment", sortable: false, class: "sv-reasonStatus100pc" },
			{ text: "Unit Status", value: "unitStatus", width: 300, align: "start", sortable: false, class: "sv-unitStatus" },
			{ text: "สรุป Plan โอน", value: "finalPlanDate", width: 180, align: "center", sortable: false, class: "sv-finalPlanDate" },
			{ text: "สรุปวันโอน(Plan+Actual)", value: "finalActualDate", width: 180, align: "center", sortable: false, class: "sv-finalActualDate" },
			{ text: "Sales Name", value: "salesName", width: 220, align: "start", sortable: false, class: "sv-salesName" },
			{ text: "CR Name", value: "crId", width: 250, align: "start", sortable: false, class: "sv-crId" },
			{ text: "Payment Method", value: "paymentMethod", width: 220, align: "start", sortable: false },
			{ text: "Agent Name", value: "agentName", width: 220, align: "start", sortable: false },
		]

		if (this.isColumnQC) {
			header.splice(header.findIndex(x => x.value == "inspection1SendRoomDate"), 0, { text: "คะแนน QC ครั้งล่าสุด", value: "qcInspection", width: 150, align: "start fixed-delivery-status", sortable: false, class: "sv-qcInspection" })
			header.splice(header.findIndex(x => x.value == "inspection1SendRoomDate"), 0, { text: "สถานะ QC ครั้งล่าสุด", value: "qcStatus", width: 180, align: "center fixed-delivery-status", sortable: false, class: "sv-qcInspection" })
		}

		if (this.pdpaHeader.length > 0) {
			this.pdpaHeader.forEach((p, index) => {
				if (p.id === config.pdpa.topic1) {
					header.splice(4, 0, { text: p.languages.filter(m => m.language == 'th')[0].name , value: "pdpaConsent1", width: 300, align: "left", sortable: false, class: "sv-qcInspection" })
				}
				if (p.id === config.pdpa.topic2) {
					header.splice(5, 0, { text: p.languages.filter(m => m.language == 'th')[0].name , value: "pdpaConsent2", width: 300, align: "left", sortable: false, class: "sv-qcInspection" })
				}
				if (p.id === config.pdpa.topic3) {
					header.splice(6, 0, { text: p.languages.filter(m => m.language == 'th')[0].name , value: "pdpaConsent3", width: 300, align: "left", sortable: false, class: "sv-qcInspection" })
				}
			})
		}

		if (this.isColumnIBNonIB) {
			header.splice(header.findIndex(x => x.value == "agentName") + 1, 0, { text: "IB/Non-IB", value: "ibNonIb", width: 200, align: "start", sortable: false })
		}

		return header
	}

	searchColumn = null
    columnNameLists = [] as any[]
	
	// refs call function by parent
	async UpdateDataTable (planningDataTable: IDataTableTransferPlanning[], pdpaHeader: PdpaApi.IPdpaCollection[], isQc: boolean, isIBNonIB: boolean) {
		this.pdpaHeader = pdpaHeader
		this.isColumnQC = isQc
		this.isColumnIBNonIB = isIBNonIB
		this.tableData = planningDataTable

		this.selected = []
		this.jsonBankLists = []
		this.setMasterDropDown()
		this.columnNameLists = this.headerDataTable()
	}

	ResetDataTable () {
		this.tableData = []
		this.selected = []
	}

	SetCheckBoxAllDataTable () {
        this.selected = this.tableData
    }

	SetCheckBoxByUnitIdDataTable (unitIds: string[]) {
		const nUnitIds = unitIds.map((u: any) => (parseInt(u)))
        this.selected = this.tableData.filter(m => nUnitIds.includes(m.unitId))
    }

	updateTimeInspection1PlanCRTime (unitId: number, dataTime: any) {
		
		let timeData = dataTime.target.value

		console.log("timeData : ", timeData)

		this.tableData = this.tableData.map(x => {
			if (x.unitId === unitId) {
				x.inspection1PlanCRTime = timeData
			}

		return x;
		})

		// console.log("this.tableData new : ", this.tableData)

	}


	updateTimeInspectionPlanCRTimeLatest (unitId: number, dataTime: any) {
		
		let timeData = dataTime.target.value

		console.log("timeData : ", timeData)

		this.tableData = this.tableData.map(x => {
			if (x.unitId === unitId) {
				x.inspectionPlanCRTimeLatest = timeData
			}

		return x;
		})

		// console.log("this.tableData new : ", this.tableData)

	}

	UpdateDataTableByUnitId (selected: any[]) {
        this.tableData = this.tableData.map(x => {
            if (selected.findIndex(item => item.unitId === x.unitId) > -1) {
                x = selected.filter(f => f.unitId === x.unitId)[0]
            }
            return x
        })
        this.selected = []
    }

	UpdateDeedNameByUnitId (unitId: number, nameLists: any[]) {
		this.tableData.filter(x => x.unitId === unitId)[0].deedName1 = nameLists[0].customerName
		this.tableData.filter(x => x.unitId === unitId)[0].deedName2 = nameLists[1].customerName
		this.tableData.filter(x => x.unitId === unitId)[0].deedName3 = nameLists[2].customerName
		this.tableData.filter(x => x.unitId === unitId)[0].deedName4 = nameLists[3].customerName
	}

	async GetUnitSelected (saveType: string, emailTypeId: number, projectId: string) {
		if (this.selected.length > 0) {
			console.log("obj :", "GetUnitSelected เข้าอยู่น่ะ")
			this.selected = this.tableData.filter(x => this.selected.findIndex(item => item.unitId === x.unitId) > -1)
			const jsonTransferSave = SetJsonTransferSave(this.selected, projectId, this.jsonBankLists, saveType, emailTypeId)
			return jsonTransferSave
		}
		return []
	}
	
	public ConditionEmailType (emailType: string) {
		console.log('conditionEmailType', emailType)
		if (emailType == "443") {

		}
	}

	// end ref

	// Btn Event Click
	BtnOpenDialogInspection (item: IDataTableTransferPlanning) {
		const refDialogInspection = this.$refs.dialogInspection as DialogInspection
		refDialogInspection.openDialog(item.unitId)
	}

	btnGotoDeedCustomer (item: any) {
		let route = this.$router.resolve({ path: `/planning/Customer/Deed?unitcode=${item.unitCode}&unitid=${item.unitId}&bookingid=${item.bookingId}` });
		window.open(route.href);
	}

	BtnOpenDeedDialog (item: IDataTableTransferPlanning) {
		const refDeedDialog = this.$refs.refDeedDialog as DeedDialog
		refDeedDialog.OpenDialog(item)
	}

	BtnOpenBankDialog (item: IDataTableTransferPlanning) { 
		if (item.transferTypeId === 41) {
			this.openNotification(`ประเภทการโอนสด ไม่สามารถเลือกธนาคารสินเชื่อได้`, "warning")
			return
		}

		const refBankDialog = this.$refs.refBankDialog as BankDialog
		const tempBankLists = this.jsonBankLists.filter(x => x.unitId === item.unitId);

		refBankDialog.openDialog(item, tempBankLists)
	}

	UpdateBankLists (bankDetails: IBankDetails) {
		
		let {unitId, bankIdUse, bankNameUse, bankLists } = bankDetails

		if (this.jsonBankLists.filter(x => x.unitId === unitId).length > 0) {
			this.jsonBankLists.filter(x => x.unitId === unitId)[0].bankLists = bankLists
		} else {
			this.jsonBankLists = this.jsonBankLists.concat(bankDetails)
		}
		
		this.tableData.filter(x => x.unitId === unitId)
		.map(d => {
			d.bankId = bankIdUse
			d.bankName = bankNameUse
			return d
		})
	}

	// dialog on column
	dialogColumnTransferCRRemark (item: IPlaningTransfer) {
		const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as any
        refDialogNoteOnColumn.openDialog(item, `${item.unitCode} : หมายเหตุ(อัพเดทระบบ Quotation, CS Report 18)`, "transferCRRemark", false)
	}

	dialogColumnBankReasonOther (item: IPlaningTransfer) {
		const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as any
        refDialogNoteOnColumn.openDialog(item, `${item.unitCode} : เหตุผลอื่นๆที่ใช้ธนาคาร`, "useBankReasonOther", false)
	}

	dialogColumnCRComment (item: IPlaningTransfer) {
		const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as any
        refDialogNoteOnColumn.openDialog(item, `${item.unitCode} : CR Note`, "crComment", false)
	}

	dialogColumnPJComment (item: IPlaningTransfer) {
		const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as any
        refDialogNoteOnColumn.openDialog(item, `${item.unitCode} : PJ Note`, "pjComment", true)
	}

	dialogColumnLettTransRemark (item: IPlaningTransfer) {
		const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as any
        refDialogNoteOnColumn.openDialog(item, `${item.unitCode} : หมายเหตุ(อัพเดทอีเมลแจ้งโอน)`, "lettTransRemark", false)
	}

	dialogColumnLettReasonStatus100pc (item: IPlaningTransfer) {
		const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as any
        refDialogNoteOnColumn.openDialog(item, `${item.unitCode} : หมายเหตุ สถานะ 100%`, "reasonStatus100pc", false)
	}
		
	validateInspection1AppointmentStatusId (item: IPlaningTransfer) {
		if (item.inspection1PlanPJDate == "") 
			this.openNotification('กรุณาให้ PJ กรอก Plan พร้อมให้เข้าตรวจ#1 มิฉะนั้นจะบันทึกข้อมูลการนัดตรวจไม่สำเร็จ!!', "warning")
	}

	// สถานะการนัด/เข้าตรวจ ล่าสุด	
	// ถ้าเป็นครั้งแรก บังคับให้กรอก ช่อง ครั้งที่ 1
	// ไม่แสดง master "เข้าตรวจแล้ว" Table [tm_VLookUp_TP] id = 48 Type = "AppointmentStatus"
	conditionDisabledInspectionAppointmentStatusLatest (item: IPlaningTransfer) {
		return item.inspectionNumLatest <= 1 ? true : false
	}
	//วันที่นัดลูกค้าล่าสุด
	conditionDisabledInspectionPlanCRDateLatest (item: any) {
		return item.inspectionNumLatest <= 1 ? true : false
	}
	// เวลาที่นัดลูกค้าล่าสุด
	conditionDisabledInspectionPlanCRTimeLatest (item: any) {
		return item.inspectionNumLatest <= 1 ? true : false
	}
	// วันที่นัดโอน	
	//	วันที่นัดโอน ถ้ามีการส่งอีเมลนัดโอนไปแล้ว และเป็นประเภทการโอนที่ไม่ใช่ โอนลอย(id 40) ห้ามแก้ จนกว่าจะส่งเมลยกเลิกนัดโอน
	//	ถ้าต้องการแก้เพื่อ ส่งเมลเลื่อนโอน ให้เลือก ประเภทการโอนเป็น เลื่อนโอนก่อน และจะบันทึกผ่านก็ต่อเมื่อ บันทึกผ่านการกด ส่งอีเมล เท่านั้น
	//	กันกรณี ลักไก่ โดยวิธี เลือกเลื่อนโอน แล้วเปลี่ยนแปลง วันที่นัดโอน แล้วกด Save
	conditionDisabledTransferDate (item: IPlaningTransfer) {
		if (item.transferTypeId !== 40 && item.flagTransferLetterBefore === true) {
			if (this.emailTypeId == "509") {
				return false
			}
			return true
		}
		return false
	}
	conditionDisabledFlagTransfer (item: IPlaningTransfer) {
		if (item.flagActiveTransfer === false) {
			return false
		}
		return true
	}
	//เดือนที่คาดว่าจะโอน
	conditionDisabledExpectTranMonth(item: any) {
		if (item.transferDateReal !== "" && item.flagActiveTransfer === true) {
			return true
		}
		return false
	}
	//สถานะการโอน
	// ถ้า active tran แล้ว ไม่ให้แก้ไข และ ปรับ สถานะเป็น "โอนแล้ว" Table [tm_VLookUp_TP] id = 35, Type = "TransferStatus"
	conditionDisabledTransferStatusId(item: any) {
		if (item.flagActiveTransfer === true) {
			return true
		}
		return false
	}
	//เหตุผลที่ใช้ธนาคาร	
	changeUseBankReason (item: IPlaningTransfer) {
		this.tableData.find(x => x.unitId === item.unitId).useBankReasonOther = this.tableData.find(x => x.unitId === item.unitId).useBankReason
	}
	//ประเภทการโอน
	// ถ้าส่งอีเมล นัดโอนแล้ว หรือ ยืนยันโอนแล้ว ห้ามแก้
	conditionDisabledTransferTypeId(item: any) {
		if (this.emailTypeId == "443" && item.flagActiveTransfer === false) {
			return false
		}
		if (item.flagTransferLetterBefore === true || item.flagActiveTransfer === true) {
			return true
		}
		return false
	}
	// todo call api approve
	changeTransferTypeId(item: any) {
		if (item.transferTypeId === 41) {
			this.dialog = true
		}
	}
	clickTransferTypeId(item: IPlaningTransfer) {
		this.tempTableData.transferTypeId = item.transferTypeId
		this.tempTableData.unitId = item.unitId
	}
	async changeTransferTypeIdConfirm () {
		this.dialog = false
		this.loading = true
		this.tableData.find(x => x.unitId === this.tempTableData.unitId).bankName = ""
		this.tableData.find(x => x.unitId === this.tempTableData.unitId).useBankReason = ""
		this.tableData.find(x => x.unitId === this.tempTableData.unitId).useBankReasonOther = ""
		this.tableData.find(x => x.unitId === this.tempTableData.unitId).usedBankCount = 0
		try { 
			await SapApi.SapApproveByUnitId({ approveAmount: "0.0", unitId: this.tempTableData.unitId })
		} catch 
		{ 
			this.openNotification("ไม่สามารถบันทึกข้อมูลวงเงินอนุมัติลง SAP ได้", "warning")
			this.dialog = false
			this.loading = false
		}

		this.dialog = false
		this.loading = false
	}
	changeTransferTypeIdCancel () {
		this.dialog = false
		this.tableData.find(x => x.unitId === this.tempTableData.unitId).transferTypeId = this.tempTableData.transferTypeId
	}

	// วันที่นัดโอนหลังการโอนลอย 
	// ถ้ามีการส่งอีเมลนัดโอนไปแล้ว และเป็นประเภทการโอน โอนลอย(id 40) ห้ามแก้ จนกว่าจะส่งเมลยกเลิกนัดโอน
	// ถ้าต้องการแก้เพื่อ ส่งเมลเลื่อนโอน ให้เลือก ประเภทการโอนเป็น เลื่อนโอนก่อน และจะบันทึกผ่านก็ต่อเมื่อ บันทึกผ่านการกด ส่งอีเมล เท่านั้น
	// กันกรณี ลักไก่ โดยวิธี เลือกเลื่อนโอน แล้วเปลี่ยนแปลง วันที่นัดโอนหลังโอนลอย แล้วกด Save
	conditionDisabledTransferPlanDateSp(item: IPlaningTransfer) {
		if (item.transferTypeId === 40 && this.emailTypeId == "509") {
			return true
		}
		if (item.flagActiveTransfer === false || item.transferTypeId !== 40) {
			return false
		}
		if (item.transferTypeId === 40 && item.flagTransferLetterBefore === true) {
			return false
		}
		return true
	}
	// ส่งเมลข้อมูลการโอน
	// ถ้าเคยส่งอีเมลไปแล้ว ให้ Edit ไม่ได้
	// ไม่เคยส่งอีเมล และ saveไว้ว่าจะส่ง(ดูจากมีวันที่ส่งอีเมลมีค่า และ flag ส่งเป็น 0) ก็ให้ ติ๊ก chk ทิ้งไว้
	conditionDisabledFlagTransferLetter (item: IPlaningTransfer) {
		if (item.flagTransferLetterBefore === true) {
			return true
		} 
		return false
	}
	conditionCheckedFlagTransferLetter (item: IPlaningTransfer) {
		if (item.flagTransferLetter === true) {
			return true
		} 
		if (item.transferLetterDate != "" && item.flagTransferLetter === false) {
			return true
		}
		return false
	}
	// ส่งเมลเปลี่ยนแปลงการโอน
	// ไม่ต้อง set ค่าเพราะ ส่งกี่ครั้งก็ได้
	// ถ้าไม่มีการส่งนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล เปลี่ยนแปลงการโอน
	conditionDisabledFlagTransferChangeLetter (item: IPlaningTransfer) {
		if (item.flagTransferLetterBefore === false) return true
	}
	// ส่งเมลเลื่อนการโอน
	// ไม่ต้อง set ค่าเพราะ ส่งกี่ครั้งก็ได้
	// ถ้าไม่มีการส่งนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล เลื่อนโอน
	conditionDisabledFlagTransferAdjustLetter (item: IPlaningTransfer) {
		if (item.flagTransferLetterBefore === false) return true
	}
	// ส่งเมลยกเลิกการโอน
	// ถ้าไม่มีการส่งนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล ยกเลิกโอน
	conditionDisabledFlagTransferCancelLetter (item: IPlaningTransfer) {
		if (item.flagTransferLetterBefore === false) return true
	}
	// ส่งเมลยกเลิกผิดนัดโอน
	// ถ้าไม่มีการส่งผิดนัดโอน ปิดไม่ให้ติ๊กส่งอีเมล ยกเลิกผิดนัดโอน
	// เช็คว่ามีประวัติวันที่ผิดนัดโอนรึเปล่า  เพราะ flag ติ๊ก ส่งผิดนัดโอน จะถูก clear เป็น 0 เสมอ
	conditionDisabledFlagTransferOutCancelLetter (item: IPlaningTransfer) {
		if (item.transferOutDateHistory === "") return true
	}

	changeStateTableItem (tableItem: any) {
        this.tableData.filter(x => x.unitId === tableItem.unitId)[0] = tableItem
    }

	conditionCrPlan (item: IPlaningTransfer) {
		console.log('conditionCrPlan', item)
		console.log('conditionCrPlan', item.crPlan)

		if (!item.crPlan) {
			return false
		}

		const today = new Date()
		today.setHours(0, 0, 0, 0)
		
		const crPlanDate = new Date(item.crPlan)
		crPlanDate.setHours(0, 0, 0, 0)

		if (crPlanDate < today) {
			this.openNotification("วันที่ CR Plan ห้ามเป็นวันย้อนหลัง", "warning")
			return false
		}

		return true
	}

	// * refs function
	callUpdateDateByColumnName (columnName: string, date: string) {
		if (this.selected.length === 0) {
			this.openNotification("กรุณาเลือกรายการที่ต้องการ update ให้คลิก checkbox เลือกยูนิตที่ต้องการ", "warning")
			return
		}
		this.selected.map((x:IPlaningTransfer) => {
			if (columnName === 'transferDateReal') x.transferDateReal = date
			if (columnName === 'crPlan') x.crPlan = date
			if (columnName === 'transferOutDateHistory') x.transferOutDateHistory = date
			return x
		})
		this.openNotification(`แก้ไขวันที่ ทั้งหมด ${this.selected.length} รายการ ได้แก่ยูนิต: ${this.selected.map(m => (m.unitCode)).join(', ')} `, "success")
	}
	callUpdateCrNameByColumnName (crId: number) {
		if (this.selected.length === 0) {
			this.openNotification("กรุณาเลือกรายการที่ต้องการ update ให้คลิก checkbox เลือกยูนิตที่ต้องการ", "warning")
			return
		}
		this.selected.map((x:IPlaningTransfer) => {
			x.crId = crId
			return x
		})
		this.openNotification(`แก้ไข CR ผู้รับผิดชอบการโอน ทั้งหมด ${this.selected.length} รายการ ได้แก่ยูนิต: ${this.selected.map(m => (m.unitCode)).join(', ')} `, "success")
	}

	async setMasterDropDown () {
		this.masterContractStatusItem = this.getMasterDataByTypeEmptyObject.concat(this.masterContractStatus)
		this.masterReceiveDataItem = this.getMasterDataByTypeEmptyObject.concat(this.masterReceivePromotionData)
		this.masterJoinEventDataItem = this.getMasterDataByTypeEmptyObject.concat(this.masterJoinEventData)
		this.masterPurposeOfBuyDataItem = this.getMasterDataByTypeEmptyObject.concat(this.masterPurposeOfBuyData)
		this.masterInspection1AppointmentStatusDataItem = this.getMasterDataByTypeEmptyObject.concat(this.masterInspection1AppointmentStatusData)
		this.masterTransferStatusItem = this.getMasterDataByTypeEmptyObject.concat(this.masterTransferStatus)
		this.masterTransferTypeItem = this.getMasterDataByTypeEmptyObject.concat(this.masterTransferType)
		this.masterBankReasonItem = this.getMasterDataByTypeEmptyObject.concat(this.masterBankReason)
		this.masterTransferPlanOperationItem = this.getMasterDataByTypeEmptyObject.concat(this.masterTransferPlanOperation)
		this.masterPayStatusTypeItem = this.getMasterDataByTypeEmptyObject.concat(this.masterPayStatusType)
		this.masterPayStatusCusOverPayTypeItem = this.getMasterDataByTypeEmptyObject.concat(this.masterPayStatusCusOverPayType)
		this.masterInspectionTime = this.initialTime()
	}

	initialTime()
	{
		let masterData = [
			{name : '09:00'},{name : '09:15'},{name : '09:30'},{name : '09:45'},
			{name : '10:00'},{name : '10:15'},{name : '10:30'},{name : '10:45'},
			{name : '11:00'},{name : '11:15'},{name : '11:30'},{name : '11:45'},
			{name : '12:00'},{name : '12:15'},{name : '12:30'},{name : '12:45'},
			{name : '13:00'},{name : '13:15'},{name : '13:30'},{name : '13:45'},
			{name : '14:00'},{name : '14:15'},{name : '14:30'},{name : '14:45'},
			{name : '15:00'},{name : '15:15'},{name : '15:30'},{name : '15:45'},
			{name : '16:00'},{name : '16:15'},{name : '16:30'},{name : '16:45'},
			{name : '17:00'},{name : '17:15'},{name : '17:30'},{name : '17:45'},
			{name : '18:00'}
		]
		return masterData;
	}

	async updatePage () {
		await TimeOut(500)
		this.changeColumnFreeze()
	}

	changeColumnFreeze () {
		SetColumnFreeze(this.columnAddressLock, this.columnCustomerNameLock)
	}

	changeComboboxCrIdOnDataTable(event: any, item: any) {
		this.tableData.filter(x => x.bookingId === item.bookingId)[0].crId = event.value
	}

	changeScrollView (cloumnName: any) {
		if (cloumnName) {
            const element = document.querySelectorAll(`[aria-label^='${cloumnName.text}']`)
            if (element) {
                TimeOut(100).then(() => {
                    element[0].scrollIntoView({ behavior: "smooth", inline: 'center'})
                })
            }
            TimeOut(500).then(() => {
                this.searchColumn = null
            })
		}
	}

	pdpaTopic1(item: any, signProspectId: string) {
		const pdpa = item.pdpa.filter((f: any) => f.identifier === `SF_${signProspectId}`)
		if (pdpa.length > 0) {
			const purposes = pdpa[0].purposes.filter((f: any) => f.id === config.pdpa.topic1)
			if (purposes.length > 0) {
				if (purposes[0].status === 'ACTIVE') return 'green'
				if (purposes[0].status === 'WITHDRAWN') return 'orange'
				if (purposes[0].status === 'NO_CONSENT') return 'orange'
			}
		}
		return ''
	}

	pdpaTopic2(item: any, signProspectId: string) {
		const pdpa = item.pdpa.filter((f: any) => f.identifier === `SF_${signProspectId}`)
		if (pdpa.length > 0) {
			const purposes = pdpa[0].purposes.filter((f: any) => f.id === config.pdpa.topic2)
			if (purposes.length > 0) {
				if (purposes[0].status === 'ACTIVE') return 'green'
				if (purposes[0].status === 'WITHDRAWN') return 'orange'
				if (purposes[0].status === 'NO_CONSENT') return 'orange'
			}
		}
		return ''
	}

	pdpaTopic3(item: any, signProspectId: string) {
		const pdpa = item.pdpa.filter((f: any) => f.identifier === `SF_${signProspectId}`)
		if (pdpa.length > 0) {
			const purposes = pdpa[0].purposes.filter((f: any) => f.id === config.pdpa.topic3)
			if (purposes.length > 0) {
				if (purposes[0].status === 'ACTIVE') return 'green'
				if (purposes[0].status === 'WITHDRAWN') return 'orange'
				if (purposes[0].status === 'NO_CONSENT') return 'orange'
			}
		}
		return ''
	}

	pdpaIcon (status: string) {
		if (status === 'green') return 'mdi-checkbox-multiple-marked-outline'
		if (status === 'orange') return 'mdi-close-box-multiple-outline'
		return 'mdi-checkbox-multiple-blank-outline'
	}

	pdpaFullName (fullNameTH: string, fullNameEN: string, nationalityId: string, status: string) {
		if (nationalityId == '2') {
			if (status === 'green') return `${fullNameTH} - ยินยอม`
			if (status === 'orange') return `${fullNameTH} - ไม่ยินยอม`
			return `${fullNameTH} - ยังไม่ได้`
		} else {
			if (status === 'green') return `${fullNameEN} - ยินยอม`
			if (status === 'orange') return `${fullNameEN} - ไม่ยินยอม`
			return `${fullNameEN} - ยังไม่ได้`
		}
	}
}
